export default __webpack_public_path__ + "static/logos-c4bd754c54c79ef6c2c5ea0eba57ffd4.svg";